import { render, staticRenderFns } from "./Organisms.vue?vue&type=template&id=32f18f34&scoped=true"
import script from "./Organisms.vue?vue&type=script&lang=js"
export * from "./Organisms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f18f34",
  null
  
)

export default component.exports